import { minLength, required } from 'ra-core'
import { DateInput, TextInput } from 'react-admin'
import React from 'react'
import { CustomFormProps } from 'types/common'
import { SUPPORTED_GEOAREAS } from 'services/geo-management/geoareas'
import KFileInput from 'ui-shared/WrappedInputs/KFileInput'
import { kampaayerRolesChoices } from 'services/cfg/form'
import { KSimpleForm } from 'ui-shared/WrappedInputs/KSimpleForm'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const KampaayerForm: React.FC<CustomFormProps> = ({ children, ...props }) => {
  return (
    <KSimpleForm {...props}>
      <KSelectInput
        source="role"
        label="form.fields.role"
        choices={kampaayerRolesChoices}
        validate={required()}
        defaultValue="admin"
      />

      <TextInput
        source="firstName"
        label="form.fields.firstName"
        validate={[required(), minLength(1)]}
      />
      <TextInput
        source="lastName"
        label="form.fields.lastName"
        validate={[required(), minLength(1)]}
      />
      <TextInput
        source="phone"
        label="form.fields.phone"
        validate={[required(), minLength(1)]}
      />
      <TextInput
        source="email"
        label="form.fields.email"
        validate={[required(), minLength(1)]}
      />
      <DateInput
        source="birthDate"
        label="form.fields.birthDate"
        validate={required()}
      />
      <TextInput
        source="birthPlace"
        label="form.fields.birthPlace"
        validate={[required(), minLength(1)]}
      />
      <TextInput
        source="residenceAddress"
        label="form.fields.residenceAddress"
        validate={[required()]}
      />
      <TextInput
        source="domicileAddress"
        label="form.fields.domicileAddress"
        validate={[required()]}
      />
      <TextInput
        source="personalNumber"
        label="form.fields.personalNumber"
        validate={required()}
      />

      {/* This will become a SelectArray input when we support multiple geoareas for a kampaayer  */}
      <KSelectInput
        source="managedGeoareas"
        choices={SUPPORTED_GEOAREAS}
        defaultValue={SUPPORTED_GEOAREAS[0].id}
        validate={required()}
      />

      <KFileInput source="kContracts" />
    </KSimpleForm>
  )
}

export default KampaayerForm
